import { EntitySettingBase } from './base';
import { ChangeAdgroupBidActionView } from '../action-view/adgroup/view';

export class AdGroupSetting extends EntitySettingBase {
  isActionNoneText() {
    return this.menuAction === 'ChangeBid';
  }

  createActionView() {
    return new ChangeAdgroupBidActionView({
      i18n: this.i18n,
      accountCurrencyCode: this.accountCurrencyCode,
      selectedRule: this.selectedRule,
      keywordBidRange: this.bidBudgetRange,
    });
  }

  setUpPreviewEntityNameAndEntityKey() {
    this.previewEntityName = this.i18n.getString('BulkEdit_AdGroup_EntityNameHeader');
    this.previewEntityKeys = ['AdgroupName'];
    this.defaultEntityValue = '';
  }

  setPreviewErrorHeaders() {
    this.previewOldHeader = this.i18n.getString('BulkEdit_AdGroup_OldBidHeader');
    this.previewNewHeader = this.i18n.getString('BulkEdit_AdGroup_NewBidHeader');
    this.previewAttempedHeader = this.i18n.getString('BulkEdit_AdGroup_AttemptedBidHeader');
  }
}
